import React from "react";
import "./styles.scss";
import HuddleLogo from "../../Onboarding/NewOnboarding/images/logo_white.gif";
export default () => (
  <a href="/" className="logo-container p-3">
    <img src={HuddleLogo} alt="logo" className="img-fluid" />
  </a>
);
